import { connect } from "react-redux"
import { reportsSelectors, reportsActions } from ".."
import ReportTable from "../components/ReportTable.js"

const mapState = state => ({
  selected: reportsSelectors.getSelectedQueryType(state),
  queryStats: reportsSelectors.getLast24Stats(state)
})

const mapDispatch = dispatch => ({
  loadQuery: queryType => dispatch(reportsActions.loadQuery(queryType))
})

const Last24 = connect(mapState, mapDispatch)(ReportTable)

export default Last24
